import React, { Component } from 'react'
import loadScript from 'load-script'

import classNames from './AreaPicker.css'
import LoadingSpinner from '../LoadingSpinner'
import ConfirmButtons from '../ConfirmButtons'
import { PRIMARY_COLOR, MAPS_API_CALLBACK, MAPS_API_URL, GEO_LOOKUP_URL } from '../../constants'

const SEARCH_DELAY = 500
const METERS_PER_MILE = 1609.34

export default class AreaPicker extends Component {
  state = {
    searchTerm: '',
    fetching: false,
    results: []
  }
  searchTimeout = null
  componentDidMount () {
    const { value: { lat, lon, radius } } = this.props
    getMapsSDK().then(maps => {
      this.map = new maps.Map(this.refs.map, {
        center: { lat, lng: lon }
      })
      this.circle = new maps.Circle({
        map: this.map,
        center: { lat, lng: lon },
        radius: radius * METERS_PER_MILE,
        strokeWeight: 0,
        fillColor: PRIMARY_COLOR,
        fillOpacity: 0.2
      })
      this.map.fitBounds(this.circle.getBounds())
      this.map.addListener('click', this.onMapClick)
      this.circle.addListener('click', this.onMapClick)
    })
  }
  onMapClick = e => {
    const { value, onChange } = this.props
    onChange({
      lat: e.latLng.lat(),
      lon: e.latLng.lng(),
      radius: value.radius
    })
  }
  componentWillReceiveProps (nextProps) {
    const { value } = this.props
    if (value.lat !== nextProps.value.lat || value.lon !== nextProps.value.lon) {
      const coords = {
        lat: nextProps.value.lat,
        lng: nextProps.value.lon
      }
      this.map.panTo(coords)
      this.circle.setCenter(coords)
    }
    if (value.radius !== nextProps.value.radius && nextProps.value.radius) {
      this.circle.setRadius(nextProps.value.radius * METERS_PER_MILE)
      this.map.fitBounds(this.circle.getBounds())
    }
  }
  onSearchChange = e => {
    clearTimeout(this.searchTimeout)
    this.setState({ searchTerm: e.target.value })
    this.searchTimeout = setTimeout(this.fetchLocations, SEARCH_DELAY)
  }
  fetchLocations = () => {
    const { searchTerm } = this.state
    const url = `${GEO_LOOKUP_URL}?address=${searchTerm}`
    this.setState({ fetching: true })
    window.fetch(url)
      .then(response => response.json())
      .then(data => {
        this.setState({
          fetching: false,
          results: data.results
        })
      })
  }
  renderResult = (result, value, onChange) => {
    const onClick = () => {
      this.setState({
        searchTerm: '',
        results: []
      })
      onChange({
        ...value,
        address: result.formatted_address,
        lat: result.geometry.location.lat,
        lon: result.geometry.location.lng
      })
    }
    return (
      <li key={result.place_id} className={classNames.resultItem}>
        <button onClick={onClick} className={classNames.resultButton}>
          {result.formatted_address}
        </button>
      </li>
    )
  }
  render () {
    const { value, onChange, updateTerm, onCancel, style } = this.props
    const { searchTerm, fetching, results } = this.state
    return (
      <div className={classNames.picker} style={style}>
        <label className={classNames.searchLabel}>
          Location search
          <div className={classNames.searchWrapper}>
            <input
              type='text'
              value={searchTerm}
              onChange={this.onSearchChange}
              placeholder='Search for a location'
            />
            {results.length !== 0 &&
              <ul className={classNames.resultList}>
                {results.map(result => this.renderResult(result, value, onChange))}
              </ul>
            }
            {fetching &&
              <LoadingSpinner className={classNames.spinner} />
            }
          </div>
        </label>
        <label className={classNames.radiusLabel}>
          Radius (m)
          <br />
          <input
            type='number'
            value={value.radius}
            min={1}
            max={1000}
            onChange={e => onChange({ ...value, radius: parseInt(e.target.value) })}
            className={classNames.radiusInput}
          />
        </label>
        <div ref='map' className={classNames.map} />
        <label>
          Current location
          <div className={classNames.currentLocation}>
            {value.address || `${value.lat.toFixed(3)}, ${value.lon.toFixed(3)}`}
          </div>
        </label>
        <ConfirmButtons
          onCancel={onCancel}
          confirmText='Submit'
          onConfirm={() => updateTerm({ type: 'location', value })}
          confirmDisabled={!value.lat || !value.lon || !value.radius}
        />
      </div>
    )
  }
}

function getMapsSDK () {
  return new Promise(resolve => {
    if (window.google) {
      resolve(window.google.maps)
    } else {
      window[MAPS_API_CALLBACK] = () => resolve(window.google.maps)
      loadScript(MAPS_API_URL)
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/search/AreaPicker.js